<div class="mx-4">
  <div class="d-flex align-items-center px-2 py-3 justify-content-between">
      <h5 class="modal-title">{{popupTitle}}</h5>
      
  </div>
  <div class="d-flex border-top border-bottom flex-column p-4 popUpCont">
      <div class="popUpCont mb-2">
          <div class="d-flex mb-3">{{popupMessage}}</div>
          <div *ngIf="showRadioButton">
              <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" [(ngModel)]="selectedOption" value="yes">
                  <label class="form-check-label" for="inlineRadio2">Yes</label>
              </div>
              <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" [(ngModel)]="selectedOption" value="no" checked="true">
                  <label class="form-check-label" for="inlineRadio1">No</label>
              </div>
          </div>
      </div>
  </div>
  <div class="d-flex justify-content-end px-2 pb-4 pt-3">
      <button *ngIf="showRadioButton" type="button" class="btn btn-primary me-2 px-3 py-1 btn-sm" [disabled]="selectedOption === 'no' || isLoading === true" (click)="confirm()">
        <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Confirm
      </button>
      <button type="button" class="btn btn-outline-secondary ms-2 btn-sm" (click)="activeModal.dismiss('Cross click')">Cancel</button>
  </div>
</div>
